// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3ksWO","text":"SelectPayment_text__3_NuX","title":"SelectPayment_title__DD7Gi","btn":"SelectPayment_btn__19zQZ"};